/*
Prakash 29-10-2022 2698811066 added styling classes for buttons
Lalitha 12/16/2022 2698811066  disable save button if account no null
Ashraf 12/16/2022  2698811066 fixed role access
Ashraf 12/19/2022  2698811066 Added action text field in add notes.
Suresh Peddavoora 01/19/2023  2698811066 Added ClassNames for action text field in add notes
Sohel 02/17/2023 2698811066 Added Sub Type Dropdown
Dilip 02/23/2023 2698811066 removed sub type dropdown
suresh peddavoora 02/28/2023 2698811066 New UI changes
Sohel 03/02/2023 2698811066 fixed Account notes dropdown issue
suresh peddavoora 02/28/2023 2698811066 New UI changes
suresh peddavoora 03/02/2023 2698811066 New UI changes
suresh peddavoora 03/08/2023 2698811066 Textfield alignments fixes
suresh peddavoora 03/13/2023 2698811066 Account summary textfields enhancements
Prakash 03/28/2023 2698811066 fixed inputfiled alignments issue.
Prakash 10/04/2023 2698811066 fixed alignments in Responsive and desktop.
Prakash 29/04/2023 2698811066 fixed alignments in button spacing issue.

*/

import React, { useState, useContext, useEffect, useCallback, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, FormHelperText, Tooltip, FormControl } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import MicIcon from '@material-ui/icons/Mic';
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import Filter from 'bad-words';
import { useUpdateEffect } from 'react-use';
import debounce from 'lodash.debounce';
import { useLocation } from 'react-router';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import Check from '@material-ui/icons/Check';
import {
  getNotesActions,
  postNotesInformation,
  resetToast,
} from '../../redux/reducers/coreWindows/Note';
import {
  cilentpostNotesInformation,
  clientNotesresetToast,
  resetPostStatus,
} from '../../redux/reducers/ClientMaintenance/AddaNote';
import PageLoader from '../PageLoader';
import { ErrorSnackbar, SuccessSnackbar } from '../CustomSnackBar';
import { profinityWords } from '../../util/ProfinityWord';
import { LANGUAGE_CODE, REGION } from '../../constants/ReusableConstants';
import { ThemeContext } from '../../themes/ThemeProvider';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import GuiTextField from '../FormComponents/GuiTextField';
import FormUpdatedContext from '../../contexts/FormUpdatedContext';
import SaveWindowDataContext from '../../contexts/SaveWindowDataContext';
import ResetWindowDataContext from '../../contexts/ResetWindowDataContext';
import { useSaveWindow } from '../../hooks/useSaveWindow';

const audioUtils = require('./audioUtils'); // for encoding audio data as PCM
const crypto = require('crypto'); // tot sign our pre-signed URL
const v4 = require('./aws-signature-v4'); // to generate our pre-signed URL
const marshaller = require('@aws-sdk/eventstream-marshaller'); // for converting binary event stream messages to and from JSON
const utilUtf8Node = require('@aws-sdk/util-utf8-node'); // utilities for encoding and decoding UTF8
const MicrophoneStream = require('microphone-stream'); // collect microphone input as a stream of raw bytes

// pre-signed url
const sampleRate = 44100;
const languageCode = LANGUAGE_CODE;
const region = REGION;
const { REACT_APP_ACCESS_KEY, REACT_APP_SECRET_KEY } = process.env;
let text = '';

// our converter between binary event streams messages and JSON
const eventStreamMarshaller = new marshaller.EventStreamMarshaller(
  utilUtf8Node.toUtf8,
  utilUtf8Node.fromUtf8,
);

function getAudioEventMessage(buffer) {
  // wrap the audio data in a JSON envelope
  return {
    headers: {
      ':message-type': {
        type: 'string',
        value: 'event',
      },
      ':event-type': {
        type: 'string',
        value: 'AudioEvent',
      },
    },
    body: buffer,
  };
}

export default function AddaNoteW8({
  transcription,
  setWebSocketOnClose,
  charLimitMsg,
  label,
  sidePanelNotes,
  disabled,
  subTypeDropDownData,
}) {
  const { reusableInputStyles, labelColor } = useContext(ThemeContext);
  const styles = reusableInputStyles();
  const useStyles = makeStyles((theme) => ({
    labelName: {
      '& .MuiOutlinedInput-input': {
        // padding: '11.3px 7px',
        fontSize: '13px',
        color: `${labelColor} !important`,
        paddingLeft: '0px !important',
      },
    },
    inputLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '600',
      },
    },

    detailsText: {
      fontSize: '0.8rem',
      fontWeight: '500',
      backgroundColor: '#FFF',
      padding: 10,
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
    specialNeeds: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      margin: '10px 0px 0px !important',
      padding: '10px 5px 5px',
      '& .MuiFormControl-marginDense': {
        marginTop: '8px !important',
        marginBottom: '8px !important',
      },
    },
    sidepanelSpecialNeeds: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      // margin: "10px !important",
      padding: '15px 10px 5px 10px',
      '&  .MuiFormControl-marginDense': {
        marginTop: '8px !important',
        marginBottom: '4px !important',
      },
    },
    micButton: {
      position: 'absolute',
      top: -20,
      right: '40px',
      alignItems: 'flex-start',

      minWidth: '30px !important',
      zIndex: 1,
      color: 'red',
    },
    stopButton: {
      position: 'absolute',
      top: -20,
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      color: 'blue',
    },
    noteblock: {
      '& .MuiInputBase-root': {
        '& .MuiInputBase-inputMultiline ': {
          paddingLeft: '0 !important',
        },
      },
    },
    buttonRoot: {
      lineHeight: 1.75,
      [theme.breakpoints.down('md')]: {
        lineHeight: 1.5,
        padding: '6px 15px',
      },
      '& .MuiButton-label': {
        fontSize: '0.813rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.688rem',
          letterSpacing: 1,
        },
      },
    },
    cancelIcon: {
      bottom: '243px',
      color: 'red',
      minWidth: '50px',
    },
    stopIcon: {
      bottom: '243px',
      color: 'blue',
      minWidth: '50px',
    },
    notesError: {
      '& .MuiFormHelperText-root': {
        bottom: '-10px !important',
        left: '10px !important',
        position: 'absolute',
      },
    },
    sidepanelMicButtonRight: {
      right: '214px',
      top: '-11px',
    },
    sidepanelstopButtonRight: {
      right: '185px',
      top: '-11px',
    },
    helperTxt: {
      color: 'blue',
      position: 'absolute',
      top: '205px',
      left: '10px',
    },
    sidepanelHelperTxt: {
      color: 'blue',
    },
  }));
  const useStyles2 = makeStyles((theme) => ({
    labelName: {
      '& .MuiOutlinedInput-input': {
        // padding: '11.3px 7px',
        fontSize: '13px',
        color: `${labelColor} !important`,
      },
    },
    inputLabel: {
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        fontWeight: '600',
      },
    },

    detailsText: {
      fontSize: '0.8rem',
      fontWeight: '500',
      backgroundColor: '#FFF',
      padding: 10,
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    },
    specialNeeds: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      // margin: "10px !important",
      padding: '15px 10px 5px 10px',
      '&  .MuiFormControl-marginDense': {
        marginTop: '8px !important',
        marginBottom: '4px !important',
      },
    },
    micButton: {
      position: 'absolute',
      top: -8,
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      color: 'red',
    },
    stopButton: {
      position: 'absolute',
      top: -8,
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
      color: 'blue',
    },

    iconButtons: {
      position: 'absolute',
      top: '60px !important',
      right: '5px',
      alignItems: 'flex-start',
      minWidth: '30px !important',
      zIndex: 1,
    },

    micButtonleft: {
      right: '230px',
    },
    micButtonRight: {
      right: '40px',
    },
    stopButtonLeft: {
      right: '200px',
    },

    saveCheckIcon: {
      '& .MuiSvgIcon-root': {
        color: 'blue',
      },
    },
    iconWidth: {
      minWidth: 35,
    },
    cancelCloseIcon: {
      '& .MuiSvgIcon-root': {
        color: 'red',
      },
    },
    buttonRoot: {
      lineHeight: 1.75,
      [theme.breakpoints.down('md')]: {
        lineHeight: 1.5,
        padding: '6px 15px',
      },
      '& .MuiButton-label': {
        fontSize: '0.813rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.688rem',
          letterSpacing: 1,
        },
      },
    },

    notesError: {
      '& .MuiFormHelperText-root': {
        bottom: '-10px !important',
        left: '10px !important',
        position: 'absolute',
      },
    },
  }));
  const location = useLocation();
  const [cancel, setCancel] = useState(false);
  const [validateNotes, setValidateNotes] = useState(false);
  const [play, setPlay] = useState(false);
  const accountNumber = location?.state?.accountNumber;
  const clientNumber = location?.state?.clientNumber;
  const dispatch = useDispatch();
  const { notesData, notesStatus, isLoading, successMsg, errorMsg, dropDownData } = useSelector(
    ({ note }) => note,
  );
  const { clientnotesStatus, clientisLoading, clientsuccessMsg, clienterrorMsg } = useSelector(
    ({ clientNotes }) => clientNotes,
  );

  useEffect(() => {
    dispatch(getNotesActions());
  }, []);

  useEffect(() => {
    reset(initialValues);
    if (notesStatus === 200) {
      setValidateNotes(false);
      stop(webSocket);
      setNotes('');
      transcription = '';
    }
    if (clientnotesStatus === 200) {
      setValidateNotes(false);
      stop(webSocket);
      setNotes('');
      transcription = '';
    }
  }, [notesStatus, clientnotesStatus]);
  const classes = useStyles();
  const classes1 = useStyles2();
  const initialValues = {
    addaNote: notesData && notesData.noteText ? notesData.noteText : '',
    action: {},
  };
  const { register, handleSubmit, errors, reset, control } = useForm({
    defaultValues: initialValues,
  });
  const filter = new Filter({ placeHolder: '*' });
  filter.addWords(...profinityWords);
  const [notes, setNotes] = useState('');
  useUpdateEffect(() => {
    if (cancel && notes?.length === 0) {
      setValidateNotes(false);
      setCancel(false);
    } else if (notes?.length === 0) {
      // setValidateNotes(true);
      // setCancel(false);
    } else {
      setValidateNotes(false);
    }
  }, [notes?.length]);
  const [webSocket, setWebSocket] = React.useState();
  const [inputSampleRate, setInputSampleRate] = React.useState();

  const handleEventStreamMessage = (messageJson) => {
    const results = messageJson.Transcript.Results;
    if (results.length > 0) {
      if (results[0].Alternatives.length > 0) {
        const transcript = decodeURIComponent(escape(results[0].Alternatives[0].Transcript));

        // if this transcript segment is final, add it to the overall transcription
        if (!results[0].IsPartial) {
          text = transcript.toLowerCase().replace(/\./g, '').replace('?', '').replace('!', '');
          transcription += filter.clean(text) + '\n';
          setNotes(`${notes ? notes : ''} ${transcription}`);
        }
      }
    }
  };

  const stop = (socket) => {
    if (socket) {
      socket.close();
      setPlay(false);
      setWebSocket(undefined);
    }
  };
  const convertAudioToBinaryMessage = (audioChunk) => {
    const raw = MicrophoneStream.toRaw(audioChunk);

    // if (raw == null) {
    //   return;
    // }

    // downsample and convert the raw audio bytes to PCM
    const downsampledBuffer = audioUtils.downsampleBuffer(raw, inputSampleRate, sampleRate);
    const pcmEncodedBuffer = audioUtils.pcmEncode(downsampledBuffer);

    // add the right JSON headers and structure to the message
    const audioEventMessage = getAudioEventMessage(Buffer.from(pcmEncodedBuffer));

    // convert the JSON object + headers into a binary event stream message
    const binary = eventStreamMarshaller.marshall(audioEventMessage);

    return binary;
  };

  const streamAudioToWebSocket = (userMediaStream) => {
    // let's get the mic input from the browser, via the microphone-stream module
    const micStream = new MicrophoneStream();

    micStream.on('format', function (data) {
      setPlay(true);
      setInputSampleRate(data.sampleRate);
    });

    micStream.setStream(userMediaStream);

    // Pre-signed URLs are a way to authenticate a request (or WebSocket connection, in this case)
    // via Query Parameters. Learn more: https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-query-string-auth.html
    const url = createPresignedUrl();

    // open up our WebSocket connection
    const socket = new WebSocket(url);
    socket.binaryType = 'arraybuffer';

    // when we get audio data from the mic, send it to the WebSocket if possible
    socket.onopen = function () {
      micStream.on('data', function (rawAudioChunk) {
        // the audio stream is raw audio bytes. Transcribe expects PCM with additional metadata, encoded as binary
        const binary = convertAudioToBinaryMessage(rawAudioChunk);

        if (socket.readyState === socket.OPEN) {
          socket.send(binary);
        }
      });
    };

    // handle inbound messages from Amazon Transcribe
    socket.onmessage = function (message) {
      // convert the binary event stream message to JSON
      const messageWrapper = eventStreamMarshaller.unmarshall(Buffer.from(message.data));
      const messageBody = JSON.parse(String.fromCharCode(...messageWrapper.body));
      if (messageWrapper.headers[':message-type'].value === 'event') {
        handleEventStreamMessage(messageBody);
      } else {
        console.error(messageBody.Message);
        stop(socket);
      }
    };

    socket.onerror = function () {
      stop(socket);
    };

    socket.onclose = function (closeEvent) {
      micStream.stop();
    };

    setWebSocket(socket);
  };
  const handleStart = () => {
    // first we get the microphone input from the browser (as a promise)...
    window.navigator.mediaDevices
      .getUserMedia({
        video: false,
        audio: true,
      })
      // ...then we convert the mic stream to binary event stream messages when the promise resolves
      .then(streamAudioToWebSocket)
      .catch(function (error) {});
  };
  useEffect(() => {
    reset(initialValues);
    setNotes(notesData.noteText);
  }, [notesData]);
  useEffect(() => {
    if (clientnotesStatus === 200) {
      setTimeout(() => {
        dispatch(clientNotesresetToast());
      }, 3000);
      dispatch(resetPostStatus());
    }
  }, [clientnotesStatus]);

  const onSubmit = (data) => {
    !notes && setValidateNotes(true);
    if (accountNumber && data.addaNote) {
      const filteredNote = data.addaNote ? filter.clean(data.addaNote) : '';
      const text = filteredNote ? filteredNote.replace(/\*/g, '') : '';
      dispatch(
        postNotesInformation({
          accountNumber: accountNumber,
          debtorNotesId: notesData.debtorNotesId,
          notes: text,
          actionPerformed: data?.actionTaken?.value ? data?.actionTaken?.value : '',
        }),
      );
      setTimeout(() => {
        dispatch(resetToast());
      }, 4000);
    } else if (clientNumber && data.addaNote) {
      const filteredNote = data.addaNote ? filter.clean(data.addaNote) : '';
      const note = filteredNote ? filteredNote.replace(/\*/g, '') : '';
      dispatch(
        cilentpostNotesInformation({
          addANote: note,
          clientNumber: clientNumber,
        }),
      );
    }
  };

  const handleSetNotes = (value) => {
    for (const i in profinityWords) {
      if (value === profinityWords[i] && value.length > 1) {
        const replacedWord =
          value.length === 2
            ? value.replace(value, '**')
            : value.length === 3
              ? value.replace(value, '***')
              : value.replace(value, '****');
        setNotes(replacedWord);
        break;
      }
    }
  };
  const debouncedSave = useCallback(
    debounce(
      (nextValue) =>
        nextValue.length <= 4
          ? handleSetNotes(nextValue) // : nextValue.length > 1
          : setNotes(filter.clean(nextValue)),
      // : setNotes(nextValue),
      2000,
    ),
    [],
  );
  const handleFilter = (value) => {
    const nextValue = value;
    setNotes(nextValue);
    nextValue && debouncedSave(nextValue);
  };
  const handleClose = () => {
    setValidateNotes(false);
    setCancel(true);
    transcription = '';
    setNotes('');
    stop(webSocket);
  };
  const handleSave = () => {
    setPlay(false);
    stop(webSocket);
    !notes && setValidateNotes(true);
  };
  useEffect(() => {
    if (!notes) {
      debouncedSave.cancel();
    }
  }, [notes]);

  const isRegisteredRef = useRef(false);
  const { updatedForms, addFormCode } = useContext(FormUpdatedContext);
  const { registerSaveFunction, unregisterSaveFunction } = useContext(SaveWindowDataContext);
  const { registerResetFunction, unregisterResetFunction } = useContext(ResetWindowDataContext);
  const { saveWindow } = useSaveWindow();
  const handleBlurEvent = () => {
    addFormCode('W8');
  };

  useEffect(() => {
    if (updatedForms.includes('W8') && !isRegisteredRef.current) {
      registerSaveFunction('W8', () => {
        handleSubmit(onSubmit);
      });
      registerResetFunction('W8', () => {
        handleClose();
      });

      return () => {
        unregisterSaveFunction('W8');
        unregisterResetFunction('W8');
      };
    }
  }, [
    updatedForms,
    registerSaveFunction,
    unregisterSaveFunction,
    registerResetFunction,
    unregisterResetFunction,
  ]);

  return (
    <div className="col-12">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          saveWindow('W8');
        }}
      >
        <div className="row">
          <div
            className={
              sidePanelNotes
                ? 'col-12  form-group new-standard-textfields'
                : 'col-md-4 col-lg-3 form-group new-standard-textfields'
            }
          >
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    {...props}
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    id="action"
                    options={dropDownData || []}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option?.value === null}
                    getOptionLabel={(option) => {
                      return option.value ? option?.value : '';
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        {...params}
                        className={` ${styles.labelName}`}
                        variant="outlined"
                        fullWidth
                        label="Action"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        // defaultValue=""
                        name="actionTaken"
                        placeholder="Select Action"
                        inputProps={{
                          ...params.inputProps,
                          // autoComplete: "off", // disable autocomplete and autofill
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                    onBlur={handleBlurEvent}
                  />
                )}
                name="actionTaken"
                control={control}
                // defaultValue={{ }}
              />
            </FormControl>
          </div>
        </div>
        <div
          className={`${classes.specialNeeds} ${classes.notesError} ${classes.noteblock} validation-text" new-standard-textfields`}
        >
          <TextField
            multiline={true}
            minRows={8}
            maxRows={20}
            margin="dense"
            variant="outlined"
            className={` ${styles.labelName}`}
            placeholder={`Enter Notes`}
            spellCheck="true"
            disabled={play}
            value={notes}
            error={validateNotes || notes?.length > 500}
            onChange={(e) => handleFilter(e.target.value)}
            // inputRef={register}
            name="addaNote"
            inputRef={register({
              maxLength: {
                value: 500,
                message: 'Cannot exceed 500 characters',
              },
            })}
            inputProps={{
              spellCheck: true,
              lang: 'en',
              maxLength: 500,
            }}
            fullWidth={true}
            onBlur={handleBlurEvent}
          />
          {!errors?.addaNote && notes?.length > 0 && notes?.length < 500 && charLimitMsg ? (
            <FormHelperText variant="outlined">
              Allows {500 - notes?.length} characters Only.
            </FormHelperText>
          ) : null}
          {notes?.length > 0 && notes?.length > 500 ? (
            <FormHelperText className="ml-3">Note cannot exceed 500 characters</FormHelperText>
          ) : null}
          {validateNotes ? (
            <FormHelperText className="ml-3">Notes is required</FormHelperText>
          ) : null}
          <Tooltip title="Start Recording">
            <Button
              // className={classes.micButton}
              className={clsx(
                classes.micButton,
                sidePanelNotes ? classes.sidepanelMicButtonRight : classes.micButtonleft,
              )}
              disabled={play}
              onClick={handleStart}
            >
              <MicIcon />
            </Button>
          </Tooltip>
          <Tooltip title="Stop Recording">
            <Button
              // className={classes.stopButton}
              className={clsx(
                classes.stopButton,
                sidePanelNotes && classes.sidepanelstopButtonRight,
              )}
              onClick={() => stop(webSocket)}
            >
              <StopRoundedIcon />
            </Button>
          </Tooltip>
        </div>
        {!sidePanelNotes && (
          <div>
            <div className="button-spacing-mb new-standard-textfields my-2">
              <Button
                onClick={() => handleClose()}
                variant="outlined"
                className={`reset-btn mr-1 ${classes.buttonRoot}`}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                className={`ml-1 search-btn ${classes.buttonRoot}`}
                onClick={() => handleSave()}
                disabled={(disabled ? disabled : false) || !accountNumber}
              >
                Save
              </Button>
            </div>
          </div>
        )}
        {sidePanelNotes && (
          <div className={`${clsx(classes1.iconButtons)}`}>
            <Tooltip title="Cancel">
              <Button
                // variant="contained"
                onClick={() => handleClose()}
                className={`${clsx(classes1.cancelCloseIcon, classes1.iconWidth)} pr-0`}
              >
                <CloseIcon />
              </Button>
            </Tooltip>
            <Tooltip title="Save">
              <Button
                // variant="contained"
                type="submit"
                onClick={() => setPlay(false)}
                className={`${clsx(classes1.saveCheckIcon, classes1.iconWidth)} pl-0`}
                disabled={isLoading}
                // disabled={notes?.length ? notes.length >= 250 : false}
              >
                <Check />
              </Button>
            </Tooltip>
          </div>
        )}
      </form>
      {(isLoading || clientisLoading) && <PageLoader />}
      {(errorMsg || clienterrorMsg) && <ErrorSnackbar errorMsg={errorMsg || clienterrorMsg} />}
      {(successMsg || clientsuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || clientsuccessMsg} />
      )}
    </div>
  );
}
function createPresignedUrl() {
  const endpoint = 'transcribestreaming.' + region + '.amazonaws.com:8443';

  // get a preauthenticated URL that we can use to establish our WebSocket
  return v4.createPresignedURL(
    'GET',
    endpoint,
    '/stream-transcription-websocket',
    'transcribe',
    crypto.createHash('sha256').update('', 'utf8').digest('hex'),
    {
      key: REACT_APP_ACCESS_KEY,
      secret: REACT_APP_SECRET_KEY,
      //   sessionToken: $('#session_token').val(),
      protocol: 'wss',
      expires: 15,
      region: region,
      query: 'language-code=' + languageCode + '&media-encoding=pcm&sample-rate=' + sampleRate,
    },
  );
}
